module.exports = "/_next/static/resources/art-abff204efa0a2b67250f5577efed3c7d.jpg";